/*
  Poter predictive search — compact dropdown under the header search bar.

  Replaces the theme's bulky #livesearch drawer with a slim panel fed by
  Shopify's predictive search API (/search/suggest.json): product rows
  (image / title / price — final price only, no compare-at) plus a
  "Kategorier" row of matching collections, headed by
  'Søgeresultater for "X"'.

  Self-contained: injects its own CSS, attaches to #search_main in the
  header. The theme's own #livesearch is hidden via the injected CSS.
*/
(function () {
  var CSS = [
    /* Hide the theme's own live-search drawer content */
    '#search #livesearch { display: none !important; }',

    /* Search bar itself: untouched — theme's original styling stays. */

    /* Dropdown panel */
    '#poter-search-panel {',
    '  position: absolute; left: 0; right: 0; top: calc(100% + 8px); z-index: 999;',
    /* Hard cap so the panel always hugs the search bar — even if some
       theme mode stretches the form itself to full width. */
    '  max-width: 520px; min-width: 300px;',
    '  background: #fff; border: 1px solid #dce3ea; border-radius: 14px;',
    '  box-shadow: 0 12px 34px rgba(20, 30, 50, 0.16); overflow: hidden;',
    '  display: none; text-align: left; font-size: 14px;',
    '}',
    '#poter-search-panel.is-open { display: block; }',
    '.poter-search__head {',
    '  display: flex; align-items: center; justify-content: space-between; gap: 12px;',
    '  padding: 12px 16px; border-bottom: 1px solid #eee5d6;',
    '}',
    '.poter-search__head-label { color: #8a7563; font-size: 12.5px; }',
    '.poter-search__all {',
    '  color: #7a4b2a; font-weight: 700; font-size: 12.5px; text-decoration: none; white-space: nowrap;',
    '}',
    '.poter-search__all:hover { text-decoration: underline; }',
    '.poter-search__list { list-style: none; margin: 0; padding: 4px 0; max-height: 420px; overflow-y: auto; }',
    '.poter-search__item a {',
    '  display: flex; align-items: center; gap: 12px; padding: 9px 16px;',
    '  color: #1f2937; text-decoration: none;',
    '}',
    '.poter-search__item a:hover { background: #faf6ef; }',
    '.poter-search__img {',
    '  width: 48px; height: 48px; flex: 0 0 48px; object-fit: contain;',
    '  border: 1px solid #eee5d6; border-radius: 8px; background: #fff;',
    '}',
    '.poter-search__title { flex: 1 1 auto; min-width: 0; font-size: 13.5px; line-height: 1.35; }',
    '.poter-search__price { flex: 0 0 auto; font-weight: 700; font-size: 13.5px; white-space: nowrap; }',
    '.poter-search__collections {',
    '  display: flex; flex-wrap: wrap; gap: 8px; padding: 12px 16px;',
    '  border-top: 1px solid #eee5d6;',
    '}',
    '.poter-search__collections a {',
    '  display: inline-block; padding: 6px 12px; border: 1px solid #e2d2b6; border-radius: 999px;',
    '  background: #f8f2e7; color: #5a3b21; font-size: 12.5px; font-weight: 600; text-decoration: none;',
    '}',
    '.poter-search__collections a:hover { background: #f0e5d1; }',
    '.poter-search__empty { padding: 18px 16px; color: #8a7563; font-size: 13px; }'
  ].join('\n');

  function injectCss() {
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function formatPrice(p) {
    // API returns e.g. "199.00" — render Danish style "199,00 kr".
    if (p == null) return '';
    var s = String(p).replace('.', ',');
    return s + ' kr';
  }

  function imgUrl(u) {
    if (!u) return '';
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=96';
  }

  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  function init() {
    var input = document.getElementById('search_main');
    var form = document.getElementById('search');
    if (!input || !form) return;

    injectCss();

    // The panel anchors to the form — ensure it can position children.
    if (getComputedStyle(form).position === 'static') form.style.position = 'relative';

    var panel = document.createElement('div');
    panel.id = 'poter-search-panel';
    form.appendChild(panel);

    var timer = null;
    var lastQ = '';
    var ctrl = null;

    function close() { panel.classList.remove('is-open'); }
    function open() { panel.classList.add('is-open'); }

    function render(q, data) {
      var res = (data && data.resources && data.resources.results) || {};
      var products = res.products || [];
      var collections = res.collections || [];
      var html = '';
      html += '<div class="poter-search__head">';
      html += '<span class="poter-search__head-label">Søgeresultater for “' + esc(q) + '”</span>';
      html += '</div>';

      if (!products.length && !collections.length) {
        html += '<div class="poter-search__empty">Ingen resultater for “' + esc(q) + '”</div>';
      }

      if (products.length) {
        html += '<ul class="poter-search__list">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          html += '<li class="poter-search__item"><a href="' + esc(p.url) + '">';
          if (img) html += '<img class="poter-search__img" src="' + esc(imgUrl(img)) + '" alt="" loading="lazy">';
          html += '<span class="poter-search__title">' + esc(p.title) + '</span>';
          html += '<span class="poter-search__price">' + esc(formatPrice(p.price)) + '</span>';
          html += '</a></li>';
        });
        html += '</ul>';
      }

      if (collections.length) {
        html += '<div class="poter-search__collections">';
        collections.forEach(function (c) {
          html += '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        });
        html += '</div>';
      }

      panel.innerHTML = html;
      open();
    }

    // Danish loves compound words: a product named "Hundesele" is ONE token,
    // but customers type "hunde sele". Shopify's predictive API prefix-matches
    // every word (AND), so "sele" never matches the token "hundesele" and the
    // query returns nothing. Fix: also query the space-stripped form
    // ("hundesele"), then merge + dedupe. Raw results rank first so exact
    // matches stay on top; the compound variant fills in what raw missed.
    function buildVariants(q) {
      var list = [q];
      var noSpace = q.replace(/\s+/g, '');
      if (noSpace && noSpace !== q) list.push(noSpace);
      return list;
    }

    function fetchOne(variant, signal) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(variant) +
        '&resources[type]=product,collection' +
        '&resources[limit]=5' +
        '&resources[options][unavailable_products]=hide';
      return fetch(url, { signal: signal, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = (data && data.resources && data.resources.results) || {};
          return { products: res.products || [], collections: res.collections || [] };
        })
        // Swallow per-request errors (incl. AbortError) so one failed/aborted
        // variant never rejects the whole merge; empty parts just contribute
        // nothing.
        .catch(function () { return { products: [], collections: [] }; });
    }

    function mergeParts(parts) {
      var products = [], collections = [];
      var seenP = {}, seenC = {};
      parts.forEach(function (part) {
        part.products.forEach(function (p) {
          var key = p.handle || p.id || p.url;
          if (key && !seenP[key]) { seenP[key] = 1; products.push(p); }
        });
        part.collections.forEach(function (c) {
          var key = c.handle || c.id || c.url;
          if (key && !seenC[key]) { seenC[key] = 1; collections.push(c); }
        });
      });
      return { products: products.slice(0, 6), collections: collections.slice(0, 6) };
    }

    function fetchSuggest(q) {
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      var signal = ctrl ? ctrl.signal : undefined;
      var variants = buildVariants(q);
      Promise.all(variants.map(function (v) { return fetchOne(v, signal); }))
        .then(function (parts) {
          // Guard against a stale response landing after the user typed more.
          if (input.value.trim() !== q) return;
          render(q, { resources: { results: mergeParts(parts) } });
        })
        .catch(function (err) {
          if (window.console) console.warn('[poter-search] suggest failed:', err);
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { lastQ = ''; close(); return; }
      timer = setTimeout(function () {
        if (q === lastQ) { open(); return; }
        lastQ = q;
        fetchSuggest(q);
      }, 250);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) open();
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
